import { apiClient } from "src/careflow/ph-core/api_client/api_client";

export async function getRolesList() {
  const data: any = await apiClient.get('/roles');

  return data;
}